import React from 'react'
import Tooltip from '../../portal/ui/Tooltip'

const PCF_CLASS_MAP: { min: string; max: string; freightClass: string }[] = [
  { min: 'N/A', max: 'N/A', freightClass: '500' },
  { min: '0.0', max: '1.0', freightClass: '400' },
  { min: '1.1', max: '2.0', freightClass: '300' },
  { min: '2.1', max: '4.0', freightClass: '250' },
  { min: '4.1', max: '6.0', freightClass: '175' },
  { min: '6.1', max: '8.0', freightClass: '125' },
  { min: '8.1', max: '10.0', freightClass: '100' },
  { min: '10.1', max: '12.0', freightClass: '92.5' },
  { min: '12.1', max: '15.0', freightClass: '85' },
  { min: 'N/A', max: 'N/A', freightClass: '77.5' },
  { min: '15.1', max: '22.5', freightClass: '70' },
  { min: '22.5', max: '30.0', freightClass: '65' },
  { min: '30.1', max: '35.0', freightClass: '60' },
  { min: '35.1', max: '50.0', freightClass: '55' },
  { min: '50.1', max: 'greater', freightClass: '50' },
]

const FreightClassPcfTable: React.FC = () => (
  <div>
    <p className="font-ttHovesMedium text-[12px] mb-2">
      Density-Based Freight Class
    </p>
    <table className="w-full text-[11px] border-collapse">
      <thead>
        <tr className="border-b border-gray-400">
          <th className="py-1 pr-2 text-left font-ttHovesMedium">Min PCF</th>
          <th className="py-1 pr-2 text-left font-ttHovesMedium">Max PCF</th>
          <th className="py-1 text-left font-ttHovesMedium">Class</th>
        </tr>
      </thead>
      <tbody>
        {PCF_CLASS_MAP.map((row, index) => (
          <tr key={index} className="border-b border-gray-200 last:border-0">
            <td className="py-[3px]">{row.min}</td>
            <td className="py-[3px]">{row.max}</td>
            <td className="py-[3px]">{row.freightClass}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
)

const FreightClassTooltip: React.FC = () => (
  <Tooltip
    content={<FreightClassPcfTable />}
    width="220px"
    align="left"
    position="bottom"
  />
)

export default FreightClassTooltip
